import request from '@/utils/request'

// 顶部设置
export function getTopWebList(data) {
  return request({
    url: `api/tbTop/webList`,
    method: 'get',
    params: data
  })
}
// 产品列表
export function getProductWebList(data) {
  return request({
    url: `api/tbProduct/webList`,
    method: 'get',
    params: data
  })
}
// 产品详情
export function getProductWebView(data) {
  return request({
    url: `api/tbProduct/webView`,
    method: 'get',
    params: data
  })
}
// 服务矩阵
export function getServeWebList(data) {
  return request({
    url: `api/tbServe/webList`,
    method: 'get',
    params: data
  })
}
// 技术与安全能力
export function getAbilityWebList(data) {
  return request({
    url: `api/tbAbility/webList`,
    method: 'get',
    params: data
  })
}
// 底部设置
export function getBottomWebList(data) {
  return request({
    url: `api/tbBottom/webList`,
    method: 'get',
    params: data
  })
}
